
<template>
    <div>
        <compWrapper title="基本信息" theme="primary">
            <!-- 录入报价中的操作中的编辑-->
            <compFormQuery v-if="querytype=='query'" class="margin-top-15 margin-right-15" :formdata="getBase" :value="formData" :labelWidth="140"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" ref="supplierEditForm" :formdata="getBase" v-model="formData" :labelWidth="120"/>
        </compWrapper>

        <compWrapper title="其他币种报价" theme="primary">
            <compFormQuery v-if="querytype=='query'" class="margin-top-15 margin-right-15" :formdata="getCurrency" :value="formData" :labelWidth="140"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" ref="supplierEditForm" :formdata="getCurrency" v-model="formData" :labelWidth="120"/>
        </compWrapper>

        <compWrapper title="其他信息" theme="primary">
            <compFormQuery v-if="querytype=='query'" class="margin-top-15 margin-right-15" :formdata="getOther" :value="formData" :labelWidth="140"></compFormQuery>
            <compFormEdit v-else class="margin-top-15 margin-right-15" ref="supplierEditForm" :formdata="getOther" v-model="formData" :labelWidth="120"/>
        </compWrapper>

        <div v-if="querytype!='query'" class="text-right">
            <vButton theme="primary" @click="submit">确认修改</vButton>
            <vButton class="margin-left-5" @click="closebox">关闭</vButton>
        </div>
    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { HttpGetOfferOne, HttpSaveOfferOne } from "@/service/proddevelop";
import dataMixin from "@/views/datamixin.js";
export default {
    props:['querytype','oneid','orderid'],
    mixins: [dataMixin],
    data(){
        return {
            formData:{},
            isShowBattery: false,
            isRequireBatteryWeight: false,
            isRequireLabelType: false
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
    },
    created(){
        this.update();
    },
    computed:{
        ...mapGetters('diction',['getAllProductPerson']),
        getUserList(){
            return this.getAllProductPerson.filter(function(item){
                // console.log(item)
                return item.label != ''
            })
        },
        getBase(){
            return [
                {
					label: "报价公司名称",
					key: "companyName",
					tag: "vInput",
				},
                {
					label: "最小起订量",
                    key:'minOrderQty',
					tag: "vInput",
                },
                {
					label: "生产周期",
                    key:'productionCycle',
					tag: "vInput",
                },
                {
					label: "报价（USD）",
                    key:'offerUsd',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "报价（CNY）",
                    key:'offerCny',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "报价有效期截至",
                    key:'validPeriodTime',
                    tag: "vDatepicker",
                    props:{
                        format:'yyyy-mm-dd',
                        confirm:false,
                    },
                },
                {
					label: "工厂产品编码",
                    key:'factoryCode',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "工厂产品编码分货号",
                    key:'articleNumber',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "交货港",
                    key:'delivery',
                    tag: "vInput",
                    required:false,
                },
                // --------------单品展开尺寸--------------
                {
					label: '单品展开尺寸（inch）',
					span:12,
					valueText:(this.formData.length?this.formData.length:'--')+" * "+(this.formData.width?this.formData.width:'--')+" * "+(this.formData.height?this.formData.height:'--'),
					show:this.querytype =='query'
				},
                {
					label: "单品展开尺寸（inch）",
                    key: "length",
                    span:5.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
						placeholder:"Length",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.length_bigmorethan',{defaultValue:'长度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },
                {
                    labelWidth:0,
                    key: "width",
                    span:3.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Width",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },
                {
                    labelWidth:0,
                    key: "height",
                    span:3,
					tag: "vInputNumber",
                    props:{
                        placeholder:"Height",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },

                // -----------单品包装尺寸-------------
                {
					label: '单品包装尺寸（inch）',
					span:12,
					valueText:(this.formData.packageLength?this.formData.packageLength:'--')+" * "+(this.formData.packageWidth?this.formData.packageWidth:'--')+" * "+(this.formData.packageHeight?this.formData.packageHeight:'--'),
					show:this.querytype =='query'
				},
                {
					label: "单品包装尺寸（inch）",
                    key: "packageLength",
                    span:5.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
						placeholder:"Length",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.length_bigmorethan',{defaultValue:'长度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },
                {
                    labelWidth:0,
                    key: "packageWidth",
                    span:3.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Width",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },
                {
                    labelWidth:0,
                    key: "packageHeight",
                    span:3,
					tag: "vInputNumber",
                    props:{
                        placeholder:"Height",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },

                {
					label: "产品毛重（lbs）",
                    key:'weight',
                    tag: "vInputNumber",
                    required:false,
                },

                // -----------外箱尺寸-------------
                {
					label: '外箱尺寸（inch）',
					span:12,
					valueText:(this.formData.outerBoxLength?this.formData.outerBoxLength:'--')+" * "+(this.formData.outerBoxWidth?this.formData.outerBoxWidth:'--')+" * "+(this.formData.outerBoxWeight?this.formData.outerBoxWeight:'--'),
					show:this.querytype =='query'
				},
                {
					label: "外箱尺寸（inch）",
                    key: "outerBoxLength",
                    span:5.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
						placeholder:"Length",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.length_bigmorethan',{defaultValue:'长度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },
                {
                    labelWidth:0,
                    key: "outerBoxWidth",
                    span:3.5,
					tag: "vInputNumber",
                    style:"padding-right:20px",
                    props:{
                        placeholder:"Width",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },
                {
                    labelWidth:0,
                    key: "outerBoxHeight",
                    span:3,
					tag: "vInputNumber",
                    props:{
                        placeholder:"Height",
					},
					on:{
						'on-blur':(value)=>{
							if(value>10000000){
								this.$VMessage.error(this.$t('erp.product.width_bigmorethan',{defaultValue:'宽度不能超过 10000000'}))
							}
						}
                    },
                    required:false,
                    show:this.querytype !='query'
                },

                {
					label: "产品净重（lbs）",
                    key:'netWeight',
                    tag: "vInputNumber",
                    required:false,
                },
                {
					label: "主材",
                    key:'material',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "附加功能",
                    key:'features',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "外箱毛重（lbs）",
                    key:'outerBoxWeight',
                    tag: "vInputNumber",
                    required:false,
                },
                {
					label: "装箱入数",
                    key:'cartonPackedQty',
                    tag: "vInputNumber",
                    required:false,
                },
                {
					label: "报关品名（英文）",
                    key:'customsEnName',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "报关品名（中文）",
                    key:'htsnameCn',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "HS CODE",
                    key:'hsCode',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "高柜整柜装柜数量",
                    key:'containerQuantity',
                    tag: "vInputNumber",
                    required:false,
                },
                {
					label: "产品描述",
                    key:'productDesc',
                    tag: "vInput",
                    required:false,
                },
                {
					label: '是否易碎',
					key: "isFragile",
					tag: "vRadio",
					show: this.type != 'query',
					valueText: this.formData.isFragile == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    required:false,
                },
                {
					label: '是否含液体',
					key: "isLiquid",
					tag: "vRadio",
					show: this.type != 'query',
					valueText: this.formData.isLiquid == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    required:false,
                },
                {
					label: '是否含有电池',
					key: "isBattery",
					tag: "vRadio",
					show: this.type != 'query',
					valueText: this.formData.isBattery == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    required:false,
                    on: {
                        "on-change": (val) => {
                            console.log(val);
                            this.isShowBattery = !!val;
                        }
                    }
                },
                {
                    label: this.$t("erp.product.battery_power", { defaultValue: "电池功率" }) + "(WH)",
                    key: "batteryPower",
                    tag: "vInputNumber",
                    show: this.isShowBattery
                },
                {
                    label: this.$t("erp.product.battery_type", { defaultValue: "电池类型" }),
                    key: "batteryType",
                    tag: "vSelect",
                    options: this.getBatteryType,
                    show: this.isShowBattery
                },
                {
                    label: this.$t("erp.product.battery_package_type", { defaultValue: "电池包装方式" }),
                    key: "batteryPackageType",
                    tag: "vSelect",
                    options: this.getBatteryPackageType,
                    show: this.isShowBattery,
                    on: {
                        "on-change": (val) => {
                            // 选中 alone in box时，电池重量必填
                            this.isRequireBatteryWeight = val == 0;
                        }
                    },
                },
                {
                    label: this.$t("erp.product.battery_weight", { defaultValue: "电池重量" }) + "（lb）",
                    key: "batteryWeight",
                    tag: "vInputNumber",
                    show: this.isShowBattery,
                    required: this.isRequireBatteryWeight
                },
                {
                    label: this.$t("erp.product.battery_label", { defaultValue: "是否已经张贴电池标" }),
                    key: "batteryLabel",
                    tag: "vRadio",
                    options: this.getIsBatteryLabel,
                    show: this.isShowBattery,
                    on: {
                        "on-change": (val) => {
                            this.isRequireLabelType = val == 1;
                        }
                    }
                },
                {
                    label: this.$t("erp.product.battery_label_type", { defaultValue: "电池标类型" }),
                    key: "batteryLabelType",
                    tag: "vSelect",
                    options: this.getBatteryLabelType,
                    required: this.isRequireLabelType,
                    show: this.isShowBattery,
                },
                {
					label: '是否带磁',
					key: "isMagnetic",
					tag: "vRadio",
					show: this.type != 'query',
					valueText: this.formData.isMagnetic == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'}),
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
                    }],
                    required:false,
                },

                {
					label: "单品包装形状",
                    key:'packageShape',
                    tag: "Select",
                    class:'minSelect',
                    options:[
                        {value:1,label:'长方体'},
                        {value:2,label:'异形体'},
                    ],
                    required:false,
                },
                {
					label: "单品包装材质",
                    key:'packageMaterial',
                    tag: "Select",
                    class:'minSelect',
                    options:[
                        {value:1,label:'纸箱'},
                        {value:2,label:'其他'},
                    ],
                    required:false,
                },
                {
					label: "外箱包装材质",
                    key:'outerBoxMaterial',
                    tag: "Select",
                    class:'minSelect',
                    options:[
                        {value:1,label:'纸箱'},
                        {value:2,label:'其他'},
                    ],
                    required:false,
                },
                {
					label: "外箱最高堆叠层数",
                    key:'outerBoxNum',
                    tag: "vInput",
                    required:false,
                },
                
            ]
        },
        getCurrency(){
            return [
                {
					label: "欧元（EUR）",
                    key:'offerEur',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "日元（JPY）",
                    key:'offerJpy',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "加元（CAD）",
                    key:'offerCad',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "英镑（GBP）",
                    key:'offerGbp',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "墨元（MXN）",
                    key:'offerMxn',
                    tag: "vInput",
                    required:false,
                },
                {
					label: "澳元（AUD）",
                    key:'offerAud',
                    tag: "vInput",
                    required:false,
                },
            ]
        },
        getOther(){
            return [
                {
					label: "开票品名",
                    key:'invoicing',
                    tag: "vInput",
                    props:{
                        placeholder:'如果有人民币采购单价，请填写'
                    },
                    required:false,
                },
                {
					label: "开票数量单位",
                    key:'invoicingNum',
                    tag: "vInput",
                    props:{
                        placeholder:'如果有人民币采购单价，请填写'
                    },
                    required:false,
                },
                {
					label: "报价人",
                    key:'offerName',
                    tag: "vInput",
                    // options:this.getUserList.map(item=>{
                    //     return {
                    //         value:item.attach.id,
                    //         label:item.label
                    //     }
                    // }),
                    required:false,
                },
                {
					label: "备注",
                    key:'remark',
                    tag: "vTextarea",
                    required:false,
                },
            ]
        }
    },
    methods:{
        update(){
            HttpGetOfferOne({
                id:this.oneid,
            }).then(res=>{
                this.formData = res.data;
                if (res.data.isBattery) {
                    this.isShowBattery = true;
                }
                if (res.data.batteryPackageType == 0) {
                    this.isRequireBatteryWeight = true;
                }
                if (res.data.batteryLabel) {
                    this.isRequireLabelType = true;
                }
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        submit(){
            // let offerone = this.getUserList.filter(item=>{
            //     return item.attach.id == this.formData.offerId
            // })[0] || {}
            HttpSaveOfferOne([{...this.formData,preselectionId:this.orderid,status:0,offerUsd:Number(this.formData.offerUsd),offerCny:Number(this.formData.offerCny)}]).then(res=>{
                this.$VMessage.success(res.message);
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            this.$emit('on-update',{...this.formData})
        },
        closebox(){
            this.$emit('on-close')
        }
    }
}
</script>